import globals from '../../../../styles/globals';

export default (theme) => ({
    ...globals(theme),
    accordion: {
        paddingTop: 5
    },
    heading: {
        color: theme.palette.text.secondary,
        background: theme.palette.primary.main,
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        height: 40
    },
    titleHeading: {
        color: 'white'
    }
});
